// localSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const localSlice = createSlice({
  name: "local",
  initialState: {
    token: localStorage.getItem("falconTokenUser") || "",
    ids: localStorage.getItem("itemId") || "",
    chatId: localStorage.getItem("chatId") || "",
    sellerId: localStorage.getItem("sellerId") || "",
    userId: localStorage.getItem("userId") || "",
    userEmail: localStorage.getItem("userEmail") || null,
    businessEmail: localStorage.getItem("businessEmail") || null,
    countryCode: localStorage.getItem("countryCode") || "",
    phoneNumber: localStorage.getItem("phoneNumber") || "",
    businesscountryCode: localStorage.getItem("businesscountryCode") || "",
    businessphoneNumber: localStorage.getItem("businessphoneNumber") || "",
    verificationType: localStorage.getItem("verificationType") || "",
    companyData: localStorage.getItem("companyData") || "",
    accountType: localStorage.getItem("accountType") || "Buyer",
    productType: localStorage.getItem("productType") || "",
    updateRating: localStorage.getItem("userRating") || null,
    subscription: localStorage.getItem("subscription") || "",
    hasSwitched: localStorage.getItem("hasSwitched") || "",
    creditcard: localStorage.getItem("creditCard") || "",
    fullName: localStorage.getItem("fullName") || "",
    qrCode: localStorage.getItem("qrCode") || "",
    isSelectingChat: false,
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("falconTokenUser", action.payload);
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
      localStorage.setItem("userId", action.payload);
    },
    setCreditcard: (state, action) => {
      const { creditCard, fullName, qrCode } = action.payload;
      state.creditcard = creditCard;
      state.fullName = fullName;
      state.qrCode = qrCode;

      localStorage.setItem("creditCard", creditCard);
      localStorage.setItem("fullName", fullName);
      localStorage.setItem("qrCode", qrCode);
    },
    setHasSwitched: (state, action) => {
      state.hasSwitched = action.payload;
      localStorage.setItem("hasSwitched", action.payload);
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
      localStorage.setItem("userEmail", action.payload);
    },
    setUserbusinessEmail: (state, action) => {
      state.businessEmail = action.payload;
      localStorage.setItem("businessEmail", action.payload);
    },
    setcountryCode: (state, action) => {
      state.countryCode = action.payload;
      localStorage.setItem("countryCode", action.payload);
    },
    setphoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
      localStorage.setItem("phoneNumber", action.payload);
    },
    setbusinesscountryCode: (state, action) => {
      state.businesscountryCode = action.payload;
      localStorage.setItem("businesscountryCode", action.payload);
    },
    setbusinessphoneNumber: (state, action) => {
      state.businessphoneNumber = action.payload;
      localStorage.setItem("businessphoneNumber", action.payload);
    },

    setIds: (state, action) => {
      state.ids = action.payload;
      localStorage.setItem("itemId", action.payload);
    },
    setChatId: (state, action) => {
      state.chatId = action.payload;
      localStorage.setItem("chatId", action.payload);
    },
    setSellerId: (state, action) => {
      state.sellerId = action.payload;
      localStorage.setItem("sellerId", action.payload);
    },
    setverificationType: (state, action) => {
      state.verificationType = action.payload;
      localStorage.setItem("verificationType", action.payload);
    },
    setAccountType: (state, action) => {
      state.accountType = action.payload;
      localStorage.setItem("accountType", action.payload);
    },
    setProductType: (state, action) => {
      state.productType = action.payload;
      localStorage.setItem("productType", action.payload);
    },
    setcompanyData: (state, action) => {
      state.companyData = action.payload;
      localStorage.setItem("companyData", JSON.stringify(action.payload));
    },
    setUpdateRating: (state, action) => {
      state.updateRating = action.payload;
      localStorage.setItem("userRating", action.payload);
    },
    setSubscription: (state, action) => {
      state.subscription = action.payload;
      localStorage.setItem("subscription", action.payload);
    },
    setIsSelectingChat: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const {
  setToken,
  setIds,
  setUserEmail,
  setcountryCode,
  setphoneNumber,
  setverificationType,
  setcompanyData,
  setbusinesscountryCode,
  setbusinessphoneNumber,
  setUserbusinessEmail,
  setAccountType,
  setUserId,
  setProductType,
  setUpdateRating,
  setSubscription,
  setHasSwitched,
  setCreditcard,
  setChatId,
  setIsSelectingChat,
  setSellerId,
} = localSlice.actions;
export default localSlice.reducer;
